import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/tooltip';
import clsx from 'clsx';

export default function ColorPickerSwatch({
  color,
  name,
  selected,
  updateColor,
}: {
  color: string;
  name?: string;
  selected?: boolean;
  updateColor: (color: string) => void;
}) {
  if (name) {
    return (
      <button type="button" onClick={() => updateColor(color)}>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <div
                className={clsx(
                  'relative m-0.5 h-6 w-6 overflow-hidden rounded-sm border border-gray-300 dark:border-gray-700',
                  selected &&
                    'border-blue-400 ring-2 ring-blue-300 outline-hidden',
                )}
                style={{ backgroundColor: color }}
              >
                {!color && (
                  <svg
                    className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform"
                    width="24"
                    height="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line
                      x1="0"
                      y1="24"
                      x2="24"
                      y2="0"
                      stroke="red"
                      strokeWidth="3"
                    />
                  </svg>
                )}
              </div>
            </TooltipTrigger>
            <TooltipContent side="bottom">
              <p>{name}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </button>
    );
  }

  return (
    <button type="button" onClick={() => updateColor(color)}>
      <div
        className={clsx(
          'relative m-0.5 h-6 w-6 overflow-hidden rounded-sm border border-gray-300 dark:border-gray-700',
          selected && 'border-blue-400 ring-2 ring-blue-300 outline-hidden',
        )}
        style={{ backgroundColor: color }}
      >
        {!color && (
          <svg
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform"
            width="24"
            height="24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line x1="0" y1="24" x2="24" y2="0" stroke="red" strokeWidth="3" />
          </svg>
        )}
      </div>
    </button>
  );
}
